import { render, staticRenderFns } from "./CodeCheck.vue?vue&type=template&id=6454831e&scoped=true&"
import script from "./CodeCheck.vue?vue&type=script&lang=js&"
export * from "./CodeCheck.vue?vue&type=script&lang=js&"
import style0 from "./CodeCheck.vue?vue&type=style&index=0&id=6454831e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454831e",
  null
  
)

export default component.exports